// extracted by mini-css-extract-plugin
module.exports = {"label":"gzzj3ko4","styledModal":"qDr_0kBm"};